import SwiperSlider from './SwiperSlider.js';

export default class TabulationNavigationSlider {
  init() {
    this.elements = Array.from(
      document.querySelectorAll('.tabulation-navigation-slider')
    );

    if (!this.elements.length) {
      return;
    }

    this.elements.forEach((element) => {
      new SwiperSlider(
        element.querySelector('.tabulation-navigation-slider__swiper'),
        {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 0,
          pagination: false,
          navigation: false,
          centerInsufficientSlides: element.classList.contains(
            'tabulation-navigation-slider--center-on-load'
          ),
          on: {
            afterInit(swiper) {
              let currentSlideIndexOnLoad = [];
              let matchingSlideIndexOnLoad = [];

              swiper.slides.forEach((slide, index) => {
                if (
                  slide.classList.contains(
                    'tabulation-navigation-slider__swiper-slide--is-current'
                  )
                ) {
                  currentSlideIndexOnLoad.push(index);
                }

                if (
                  slide.classList.contains(
                    'tabulation-navigation-slider__swiper-slide--is-matching'
                  )
                ) {
                  matchingSlideIndexOnLoad.push(index);
                }
              });

              if (currentSlideIndexOnLoad.length) {
                swiper.slideTo(currentSlideIndexOnLoad[0]);

                return;
              }

              if (matchingSlideIndexOnLoad.length) {
                swiper.slideTo(matchingSlideIndexOnLoad[0]);
              }
            },
          },
        }
      );
    });
  }
}
